import React, { Component } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import Icon from "@material-ui/core/Icon";

class Tools_node_js_2_json extends Component {
  constructor(props) {
    super(props);

    this.state = {
      txtNode: "",
      txtJSON: "",
    };
  }
  txtNode_change(e, event) {
    this.setState({
      txtNode: event.target.value,
    });
  }

  txtJSON_change(e, event) {
    this.setState({
      txtJSON: event.target.value,
    });
  }

  convertNode2JSON() {
    var n = this.state.txtNode;
    n = n.split("\n");

    for (var i = 0; i < n.length; i++) {
      n[i] = n[i].trim();
      n[i] = n[i].split("://").join(":/+++/")

      if (n[i].indexOf("//") !== -1) {
        n[i] = n[i].substring(0, n[i].indexOf("//"));
      }
      n[i] = n[i].split(":/+++/").join("://")
    }

    n = n.filter(function (line) {
      return line.length > 0;
    });

    n = n = n.join("\n");

    n = n.split("\\").join("\\\\");
    n = n.split('"').join('\\"');
    n = n.split("\n").join("\\n");

    this.setState({
      txtJSON: n,
    });
  }

  convertJSON2Node() {
    var n = this.state.txtJSON;
    n = n.split("\\n").join("\n");
    n = n.split('\\"').join('"');
    n = n.split("\\\\").join("\\");

    this.setState({
      txtNode: n,
    });
  }

  render() {
    return (
      <div className="row" id="node_js_2_json">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Node.js 2 JSON</h2>
              <p>
                Nexoid interface models allow components to run node.js code on
                user events. This is a great way to add clever functionality to
                your record forms. It can be a little frustrating converting
                multiline Node.js into single line JSON strings. This tool is a
                simple code rewriter which will convert between no GS and JSON
                strings.
              </p>

              <TextField
                label="Node.js"
                value={this.state.txtNode}
                onChange={this.txtNode_change.bind(this, this)}
                margin="normal"
                fullWidth={true}
                placeholder={"Node.js Code"}
                multiline={true}
                rowsMax={16}
                autoFocus={false}
              />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginRight: 16,
                  marginTop: 32,
                  marginBottom: 8,
                  backgroundColor: "#0099ed",
                }}
                onClick={(e) => this.convertJSON2Node()}
              >
                <Icon style={{ marginRight: 8 }}>arrow_upward</Icon>
                Convert to Node.js
              </Button>

              <Button
                variant="contained"
                color="primary"
                style={{
                  marginRight: 16,
                  marginTop: 32,
                  marginBottom: 8,
                  backgroundColor: "#0099ed",
                }}
                onClick={(e) => this.convertNode2JSON()}
              >
                <Icon style={{ marginRight: 8 }}>arrow_downward</Icon>
                Convert to JSON String
              </Button>

              <TextField
                label="JSON"
                value={this.state.txtJSON}
                onChange={this.txtJSON_change.bind(this, this)}
                margin="normal"
                fullWidth={true}
                placeholder={"JSON string"}
                autoFocus={false}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Tools_node_js_2_json;



// WEBPACK FOOTER //
// ./src/components/knowlege/integration/Tools_node_js_2_json.js